/**
 * 电子合同预览抽屉（checkout 内嵌签署，不引电子签章 SDK）
 */
import type { ReactNode } from 'react';

interface ContractPreviewProps {
  open: boolean;
  onClose: () => void;
  title?: string;
  children?: ReactNode;
  footer?: ReactNode;
}

export default function ContractPreview({ open, onClose, title, children, footer }: ContractPreviewProps) {
  if (!open) return null;

  return (
    <div className="modal-mask" onClick={onClose}>
      <div className="modal-panel contract-modal" onClick={(e) => e.stopPropagation()}>
        <div className="modal-head">
          <span className="modal-title">{title ?? '电子买卖合同预览'}</span>
          <button className="modal-close" onClick={onClose} aria-label="关闭">×</button>
        </div>
        <div className="modal-body contract-body">{children}</div>
        {footer ? <div className="modal-foot">{footer}</div> : null}
      </div>
    </div>
  );
}
